import { render } from "./IPPhonesModule.vue?vue&type=template&id=0e995ed8&scoped=true"
import script from "./IPPhonesModule.vue?vue&type=script&lang=js"
export * from "./IPPhonesModule.vue?vue&type=script&lang=js"

import "./IPPhonesModule.vue?vue&type=style&index=0&id=0e995ed8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0e995ed8"

export default script